import React, { useContext, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import TableTBody from './TableTBody';
import TableContext from './TableContext';
const ExpandableTableTBody = function ExpandableTableTBody(props) {
    const { tableStore: { isBodyExpanded } } = useContext(TableContext);
    const rendered = useRef(false);
    if (isBodyExpanded || rendered.current) {
        rendered.current = true;
        return (React.createElement(TableTBody, Object.assign({}, props, { hidden: !isBodyExpanded })));
    }
    return null;
};
ExpandableTableTBody.displayName = 'ExpandableTableTBody';
export default observer(ExpandableTableTBody);
